//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import webpSupport from "@/mixins/webpSupport";
import UiLazyImg from "../Ui/UiLazyImg.vue";

export default {
  name: "ProductCard",
  components: {
    UiLazyImg,
    VueSlickCarousel
  },
  mixins: [
    webpSupport
  ],
  props: {
    info: {
      type: Object,
      default() {
        return {}
      }
    },
    selectedGemstone: {
      type: String,
      default: ''
    },
    selectedMetal: {
      type: String,
      default: ''
    },
    productsLoading: {
      type: Boolean,
      default: false
    },
    showAltAsset: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      showMobileStones: false,
      productGemstone: '',
      productMetal: '',
      productInlay: '',
      reducedProductCategories: [
        'rings',
        'earrings'
      ],
      mediaLoaded: false
    }
  },
  watch: {
    productsLoading(val) {
      if(!val) {
        this.setFilterParams();
      }
    }
  },
  computed: {
    attributes() {
      let attributes = this.$store.getters.getBootstrap?.data?.attributes || [];
      if(attributes && !Array.isArray(attributes)) {
        attributes = Object.entries(attributes).map((item) => (item[1]));
      }
      return attributes;
    },
    reducedProduct() {
      return this.reducedProductCategories.includes(this.info.category_code);
    },
    mdView() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    defaultConfig() {
      return this.info.configs.find(item => item.default) || this.info.configs[0];
    },
    currentConfigLink() {
      return `/product/${this.info.slug}?configId=${this.currentConfig.pdp_sku}${this.defaultSizeQuery(this.currentConfig)}`;
    },
    currentConfig() {
      const config = this.getCurrentConfig();
      this.setConfigImages(config, 'images');
      this.setConfigImages(config, 'images_angled');
      return config;
    },
    currentStoneInfo() {
      if(!this.info.stones?.length || !this.currentConfig?.stone_type_slug) {
        return;
      }
      return this.info.stones.find(item => item.sku === this.currentConfig.stone_type_slug);
    },
    currentInlayInfo() {
      if(!this.info.inlays?.length || !this.currentConfig?.inlay_type_slug) {
        return;
      }
      return this.info.inlays.find(item => item.sku === this.currentConfig.inlay_type_slug);
    },
    hasValentinesDaySale() {
      return this.currentConfig.badge && this.currentConfig.badge.type === this.$store.state.holidayCodes.valentines_day
    },
    showDesignYoursLabel() {
      return this.info?.stones?.length > 1 || this.info?.inlays?.length > 1;
    },
  },
  methods: {
    isConfigAvailable(item) {
      return this.info.configs?.some(config => config.metal_type_slug === item.metalSku
        && config.stone_type_slug === item.gemstoneSku
        && config.inlay_type_slug === item.inlaySku);
    },
    setMediaLoad() {
      this.mediaLoaded = true;
    },
    defaultSizeQuery(config) {
      let result = '';
      if(this.$store.getters.getForcedSizeProductsSlug.includes(this.info.vendor_model)) {
        return result;
      }
      const attributes = config.attributes ? Object.values(config.attributes) : [];
      attributes.forEach(item => {
        if(this.attributes.some(someItem => someItem.id === item && (someItem.group_id === this.$productServiceData.attributeGroupsList.ringSize || someItem.group_id === this.$productServiceData.attributeGroupsList.necklaceSize))) {
          result = '&size=default';
        }
      })
      return result;
    },
    setProductFilter(filterKey, filterValue) {
      this[filterKey] = filterValue;
    },
    clickOutside() {
      this.showMobileStones = false;
    },
    mouseover() {
      this.$refs?.video?.play();
    },
    mouseleave() {
      this.$refs?.video?.pause();
    },
    setConfigImages(config, imagesKey) {
      if(!config?.[imagesKey]) {
        return;
      }
      const configImages = [];
      Object.keys(config[imagesKey]).sort((a, b) => a.substring(1) - b.substring(1)).forEach(key => {
        const configImg = config[imagesKey][key].webp && this.isWebpSupported ? config[imagesKey][key].webp :  config[imagesKey][key].png;
        configImages.push(configImg);
      });
      config[imagesKey] = configImages;
    },
    setFilterParams() {
      this.productGemstone = this.selectedGemstone || this.defaultConfig?.stone_type_slug;
      this.productMetal = this.selectedMetal || this.defaultConfig?.metal_type_slug;
      this.productInlay = this.defaultConfig?.inlay_type_slug;
    },
    getCurrentConfig() {
      let config = JSON.parse(JSON.stringify(this.defaultConfig));
      let configList = JSON.parse(JSON.stringify(this.info.configs));
      configList = configList.filter(item => item.metal_type_slug === this.productMetal);
      configList = configList.filter(item => item.stone_type_slug === this.productGemstone);
      configList = configList.filter(item => item.inlay_type_slug === this.productInlay);
      if(configList?.length) {
        config = configList[0];
      }
      return config;
    },
    getStoneIcon(stone) {
      return stone.sku === 'NO' && this.info?.metals?.find(item => item.sku === this.productMetal)?.icon_url || stone.icon_url;
    },
    getInlayIcon(inlay) {
      return inlay.sku === 'ILNO' && this.productMetal === this.$store.getters.getMetalType.silver.sku && '/images/catalog/brushed-white.png' || inlay.icon_url;
    },
  },
  created() {
    this.setFilterParams();
  }
}
